import { render } from "./PatientForm.vue?vue&type=template&id=0d289ebe&scoped=true&ts=true"
import script from "./PatientForm.vue?vue&type=script&lang=ts"
export * from "./PatientForm.vue?vue&type=script&lang=ts"

import "./PatientForm.vue?vue&type=style&index=0&id=0d289ebe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d289ebe"]])

export default __exports__